
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/companies/[organizationId]/people",
      function () {
        return require("private-next-pages/admin/companies/[organizationId]/people.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/companies/[organizationId]/people"])
      });
    }
  